import { getGraphQLErrors } from 'lib/helpers/getGraphQLErrors/getGraphQLErrors'

interface IsApolloErrorWithCodeOptions {
  code: string
}

/** Whether any GraphQL error the failure carries was tagged with `code`. */
export const isApolloErrorWithCode = (error: unknown, { code }: IsApolloErrorWithCodeOptions): boolean =>
  getGraphQLErrors(error).some(({ extensions }) => extensions?.code === code)
